export default {
    filterBar: {
        sideFilterAria: 'Filter strani',
        countryFilterAria: 'Filter države',
        allCountriesAria: 'Prikaži pogodbe iz vseh držav',
        hrOnlyAria: 'Prikaži samo HR pogodbe',
        siOnlyAria: 'Prikaži samo SI pogodbe',
    },
}
